export const unreachable = (v: never): never => {
  console.error("Reached unreachable case:", v);
  throw new Error("Runtime error");
};
